import { CustomFieldResourceType } from "@wingspanhq/wingspan-api-sdk";

export type CustomFieldResourceTypeRouteSlug = "collaborator" | "line-item";

export const CustomFieldResourceTypeSlug: {
  [CustomFieldResourceType.PAYEE]: CustomFieldResourceTypeRouteSlug;
  [CustomFieldResourceType.LINE_ITEM]: CustomFieldResourceTypeRouteSlug;
} = {
  [CustomFieldResourceType.PAYEE]: "collaborator",
  [CustomFieldResourceType.LINE_ITEM]: "line-item"
};

export const ResourceTypeSlugToResourceType: Record<
  CustomFieldResourceTypeRouteSlug,
  CustomFieldResourceType
> = {
  collaborator: CustomFieldResourceType.PAYEE,
  "line-item": CustomFieldResourceType.LINE_ITEM
};
